<div class="p-4 border-bottom">
  <div class="d-flex align-items-center mb-3">
    <div class="shrink-0">
      <div class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3" 
           style="width: 50px; height: 50px; font-size: 18px; font-weight: bold;">
        {{getUserInitials()}}
      </div>
    </div>
    <div class="grow">
      <h4 class="mb-0 fw-bold">{{getUserFullName()}}</h4>
      <small class="text-muted">{{user?.email}}</small>
    </div>
  </div>
</div>